import { supabase } from './supabase'
import { detectContactDetails, contactExcerpt } from './contactDetection'

// Checks text for contact details and, if found, logs it for the admin
// Flags tab (Admin → Flags). Returns the detection result.
// location: 'message' | 'wanted' | 'listing'
export async function checkAndLogContact(location, text, refId = null) {
  const result = detectContactDetails(text)
  if (result.found) {
    try {
      await supabase.rpc('log_contact_flag', {
        p_location: location,
        p_ref_id: refId,
        p_kinds: result.kinds,
        p_excerpt: contactExcerpt(text, result.matches),
      })
    } catch (e) {
      // never block the user because logging failed
    }
  }
  return result
}
